import Link from 'next/link';
import Image from 'next/image';

// Both logos render server-side; theme swap is pure CSS (`dark:` scoping),
// so there is no null-until-mounted blank flash and no layout shift.
const Logo = () => (
  <Link href="/#inicio" aria-label="Mendly — inicio" className="inline-flex">
    <Image
      alt="Mendly"
      width={1111}
      height={194}
      src="/logo/default-logo.svg"
      priority
      className="h-7 w-auto dark:hidden"
    />
    <Image
      alt="Mendly"
      width={1111}
      height={194}
      src="/logo/default-logo-dark.svg"
      priority
      className="hidden h-7 w-auto dark:block"
    />
  </Link>
);

export default Logo;
